module.exports = __webpack_public_path__ + "static/media/co_drawer_right.5bc522ff.svg";